import CustomIcon from "../../../../components/CustomIcon";
import ToggleSwitch from "../../../../components/toggleSwitch/ToggleSwitch";
import {addCities, enableDisableCity, enableDisableProvince, renameCity} from "../../../../redux/slices/locationSlice";
import CustomButton, {DangerButton} from "../../../../components/CustomButton";
import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import CustomModal from "../../../../components/CustomModal";
import Input from "../../../../components/form/Input";
import {AddCitiesModal} from "../AddCitiesModal";

const CityDetail = ({setIsAddingAreas, isAddingCities, setIsAddingCities}) => {
  const {
    province,
    city,
    currentCity,
    currentProvince,
    processing
  } = useSelector((state => state.location))

  const dispatch = useDispatch();

  useEffect(() => {
    setIsAddingCities(false)
  }, [city])


  return (
    <>
      <div className="px-4 py-4 bg-white shadow rounded-xl space-y-2">
        <div className="flex justify-between">
          <h1>City</h1>
        </div>
        <div className="flex justify-between">
          {province.loading || city.loading ?
            <div className="w-48 h-6 bg-secondary-100"/> :
            <label className="font-bold">{currentCity?.name}</label>
          }

          <ToggleSwitch isChecked={!currentCity?.disabled}
                        isDisabled={province.loading || city.loading || currentProvince.disabled}
                        onChange={() => {
                          //TODO setCurrentCity({...currentCity, disabled: !currentCity?.disabled})
                          dispatch(enableDisableCity({cityId: currentCity?.id, value: !currentCity?.disabled}))
                        }}/>
        </div>
        <div className="flex py-5 space-x-5">
          <div>Allow for campaign</div>
        <ToggleSwitch isChecked={currentCity?.campaign_location ?? false}
                      isDisabled={province.loading || city.loading || !currentProvince.campaign_location}
                      onChange={() => {
                        dispatch(enableDisableCity({
                          cityId: currentCity?.id,
                          value: !currentCity?.campaign_location,
                          isCampaign: true
                        }))

                      }}/>
        </div>
        <CustomButton disabled={province.loading || city.loading} onClick={() => setIsAddingAreas(true)}>
          Add Areas
        </CustomButton>
      </div>
      {/*add cities under province*/}
      {isAddingCities && <AddCitiesModal disabled={processing} showModal={isAddingCities} setShowModal={setIsAddingCities}
                                         onAdd={(cities) => {
                                           dispatch(addCities({provinceId: currentProvince?.id, cities: cities}))
                                         }}/>
      }
    </>
  )
}

export default CityDetail;
